// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"95":"9ebd8ab4","239":"882cb3c4","286":"3564eec7","315":"e603eef6","453":"62fc49b2","522":"59cc0550","639":"f9dbe755","732":"dea8aa0c","773":"27622993","831":"fb58f780","977":"8f1e81cd"}[chunkId] + ".chunk.js";
};